/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {
  createAdnHttpResource,
  createAdnHttpResourceAction,
  createAdnHttpResourceSender
} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the Advertiser HTTP resource (factory product). */
export class AdvertiserResource {
}

export function createAdvertiserResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const Advertiser = createAdnHttpResource(send, 'advertisers', () => localUserProfile);
  Advertiser.emailInvite = createAdnHttpResourceAction(send, {
    method: 'POST',
    url: ApiConfig.obtain().getVersionedUri('advertisers') + '/emailinvite/:id'
  });
  return Advertiser;
}

export const advertiserResourceProvider = {
  provide: AdvertiserResource,
  useFactory: createAdvertiserResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

